import EpisodePage from './EpisodePageContainer';

export default EpisodePage;
